import React from 'react';
import styled from 'styled-components';
import CaresenseLayout, {
  StickyLink,
} from 'components/Caresense/CaresenseLayout';
import { getCaresenseErrorMessage } from './caresenseErrors';
import { getBranding } from 'utils/branding';
import { palette } from '../AnyfitMall/theme';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem 1rem;
  min-height: 300px;
`;

const ErrorIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #fff2f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;

  &::before {
    content: '';
    width: 32px;
    height: 32px;
    background-color: #ff4d4f;
    mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E")
      center/contain no-repeat;
    -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2'%3E%3Cline x1='18' y1='6' x2='6' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='6' x2='18' y2='18'%3E%3C/line%3E%3C/svg%3E")
      center/contain no-repeat;
  }
`;

const ErrorTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${palette.Gray900};
  margin-bottom: 1rem;
  font-family: 'Noto Sans KR', sans-serif;
`;

const ErrorMessage = styled.p`
  font-size: 1rem;
  color: ${palette.Gray600};
  line-height: 1.6;
  font-family: 'Noto Sans KR', sans-serif;
`;

/**
 * 케어센스 전용 에러 페이지
 * Division에 따라 "애니핏 플러스" 또는 "애니핏 프로" 앱으로 이동
 */
const CaresenseError = () => {
  const branding = getBranding();

  return (
    <CaresenseLayout
      footer={
        <StickyLink href={branding.deepLink}>
          {branding.name} 앱으로 이동
        </StickyLink>
      }
    >
      <ErrorContainer>
        <ErrorIcon />
        <ErrorTitle>연동 실패</ErrorTitle>
        <ErrorMessage>{getCaresenseErrorMessage()}</ErrorMessage>
      </ErrorContainer>
    </CaresenseLayout>
  );
};

export default CaresenseError;
